import i18next from 'i18next';

import { DELIVERY_STATUS } from '~constants/delivery';

i18next.addResources('es_CL', 'DeliveryStatus', {
  [DELIVERY_STATUS.REJECTED]: 'Rechazado',
  [DELIVERY_STATUS.EXPIRED]: 'Caducado',
  [DELIVERY_STATUS.PREORDER]: 'Por confirmar',
  [DELIVERY_STATUS.CONFIRMED]: 'Confirmado',
  [DELIVERY_STATUS.CANCELLED]: 'Cancelado',
  [DELIVERY_STATUS.IN_PROGRESS]: 'En proceso',
  [DELIVERY_STATUS.NEAR_PICKUP]: 'Retirando',
  [DELIVERY_STATUS.PICKED_UP]: 'Entregando',
  [DELIVERY_STATUS.NEAR_DROPOFF]: 'Por entregar',
  [DELIVERY_STATUS.COMPLETED]: 'Completado',
  [DELIVERY_STATUS.NO_DELIVERY]: 'Sin delivery',
  [DELIVERY_STATUS.CONFIRMING]: 'Confirmando',
  assign: 'Asignar',
  app: 'App',
  mercat: 'Mercat',
  appUberEats: 'Uber Eats',
  appRappi: 'Rappi',
  appPedidosYa: 'PedidosYa',
  appAmipass: 'Amipass',
  appDidi: 'Didi'
});

i18next.addResources('es_CR', 'DeliveryStatus', {
  [DELIVERY_STATUS.REJECTED]: 'Rechazado',
  [DELIVERY_STATUS.EXPIRED]: 'Caducado',
  [DELIVERY_STATUS.PREORDER]: 'Por confirmar',
  [DELIVERY_STATUS.CONFIRMED]: 'Confirmado',
  [DELIVERY_STATUS.CANCELLED]: 'Cancelado',
  [DELIVERY_STATUS.IN_PROGRESS]: 'En proceso',
  [DELIVERY_STATUS.NEAR_PICKUP]: 'Retirando',
  [DELIVERY_STATUS.PICKED_UP]: 'Entregando',
  [DELIVERY_STATUS.NEAR_DROPOFF]: 'Por entregar',
  [DELIVERY_STATUS.COMPLETED]: 'Completado',
  [DELIVERY_STATUS.NO_DELIVERY]: 'Sin delivery',
  [DELIVERY_STATUS.CONFIRMING]: 'Confirmando',
  assign: 'Asignar',
  app: 'App',
  mercat: 'Mercat',
  appUberEats: 'Uber Eats',
  appRappi: 'Rappi',
  appPedidosYa: 'PedidosYa',
  appAmipass: 'Amipass',
  appDidi: 'Didi'
});
